(function () {
    'use strict';
    angular.module('doclr.components', []);
})();